import React from 'react';
import {BrowserRouter, Routes, Route, Navigate} from 'react-router-dom';
import {Toaster} from 'react-hot-toast';
import {useUserStore} from './store/userStore';
import Auth from './pages/Auth';
import Lobby from './pages/Lobby';
import Room from './pages/Room';
import VoiceLab from "./pages/VoiceLab";
import LabLandingPage from "./pages/VoiceLab/Landing";

function App() {
    const ProtectedRoute = ({children}) => {
        const isAuthenticated = useUserStore((state) => state.isAuthenticated());
        return isAuthenticated ? children : <Navigate to="/"/>;
    };

    return (
        <BrowserRouter>
            <Toaster
                position="top-right"
                toastOptions={{
                    duration: 4000,
                    style: {
                        background: 'rgba(255, 255, 255, 0.5)',
                        backdropFilter: 'blur(10px)',
                        color: '#070707',
                        border: '1px solid rgba(255, 255, 255, 0.2)',
                    },
                    success: {
                        iconTheme: {
                            primary: '#22c55e',
                            secondary: '#fff',
                        },
                    },
                    error: {
                        iconTheme: {
                            primary: '#ef4444',
                            secondary: '#fff',
                        },
                    },
                }}
            />
            <Routes>
                <Route path="/" element={<Auth/>}/>
                <Route
                    path="/lobby"
                    element={
                        <ProtectedRoute>
                            <Lobby/>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/room/:roomCode"
                    element={
                        <ProtectedRoute>
                            <Room/>
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="/voice-lab"
                    element={
                        <ProtectedRoute>
                            <LabLandingPage/>
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="/voice-lab/:roomCode"
                    element={
                        <ProtectedRoute>
                            <VoiceLab/>
                        </ProtectedRoute>
                    }
                />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
